import { render } from "./TelegramComments.vue?vue&type=template&id=e0abc6f6"
import script from "./TelegramComments.vue?vue&type=script&lang=js"
export * from "./TelegramComments.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__